// extracted by mini-css-extract-plugin
export var container = "_o9-0";
export var dotAnimation = "_o9-2";
export var dotsLoading = "_o9-1";